<template>
  <div class="auto dropDownAgency">
    <multiselect
      deselect-label
      select-label
      open-direction="bottom"
      track-by="id"
      label="name"
      :options="acAgencies"
      :multiple="false"
      placeholder="Busque por agencia"
      :show-no-results="false"
      @select="selectOpt"
    >
      <template slot="noOptions">
        <span v-html="'Digite el nombre de la agencia'"></span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  props: {
    acAgencies: Array,
  },
  methods: {
    selectOpt: function (opt) {
      window.location.href = opt.agencyUrl;
    },
  },
};
</script>
